
import { AuthorThemedLotsModel } from '../models/AuthorThemedLotsModel.js';
import { AuthorThemedLotsView } from '../views/AuthorThemedLotsView.js';

export class AuthorThemedLotsController {
    constructor() {

        this.model = new AuthorThemedLotsModel();
        this.view = new AuthorThemedLotsView();

        this.model.subscribe(state => this.view.render(state));
    }
}